import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { CommercialService } from '../../commercial.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { business_types } from '../../../../../assets/business-types';
import { currentProviderList } from '../../../../../assets/energy-providers-tx';
import { environment } from '../../../../../environments/environment';
import { Subject } from 'rxjs/internal/Subject';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
} from '@angular/animations';
import { nextTick } from 'q';

@Component({
  selector: 'app-cq3',
  templateUrl: './cq3.component.html',
  styleUrls: [
    './cq3.component.css',
    '../commercial-questionnaire.component.css',
  ],
  animations: [
    trigger('flyInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate(
            '0.4s 0.1s ease',
            style({
              transform: 'translateX(0)',
            })
          ),
          animate(
            '0.4s ease',
            style({
              opacity: 1,
            })
          ),
        ]),
      ]),
      transition('* => void', [
        group([
          animate(
            '0.4s ease',
            style({
              transform: 'translateX(50px)',
            })
          ),
          animate(
            '0.4s 0.2s ease',
            style({
              opacity: 0,
            })
          ),
        ]),
      ]),
    ]),
  ],
})
export class Cq3Component implements OnInit {
  @Input() data: any;
  questions = [];
  userResponses = [];
  question;
  questionObj;
  disablebutton = false;
  showbutton = true;
  deviceWidth;
  question_sub1;
  question_sub2;
  question_sub3;
  businessTypes;
  level1;
  level2;
  level3;
  sub_levels = [];
  sub_levels2 = [];
  user_bot = false;
  showTyping = false;
  timer;
  typingTimer;
  time = 1000;
  currentProvider;
  energy_providers_list;
  url = environment.api_url;
  private unsubscribe = new Subject<void>();
  constructor(
    private commercialService: CommercialService,
    private ref: ChangeDetectorRef,
    private http: HttpClient
  ) {
    this.questions = this.commercialService.getQues();
    this.deviceWidth = this.commercialService.deviceWidth;
    this.userResponses = this.commercialService.userResponse.userResponses;
    this.businessTypes = business_types;
    this.energy_providers_list = currentProviderList.texas_ep;
  }

  ngOnInit() {
    this.commercialService.currentId = this.data;
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].com_question;
        this.questionObj = this.questions[i];
        let questionName = !_.isEmpty(this.userResponses[1])
          ? this.userResponses[1].fieldValue.toString().replace(/\s+$/, '')
          : '';
        this.question = this.question.replace(
          '<Firstname>',
          this.titleCase(questionName)
        );
        if (this.deviceWidth > 768) {
          const question_sub1 = this.question.split(
            this.titleCase(questionName) + '! '
          );
          this.question_sub1 =
            question_sub1[0] + this.titleCase(questionName) + '! ';
          this.question_sub2 = question_sub1[1];
        }
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, {
        com_question_id: this.questionObj._id,
      });
      this.level1 = obj != undefined ? obj.fieldValue : '';
    }

    if (this.deviceWidth > 768) 
    {
      

      if (_.isEmpty(this.level1)) {
        this.disablebutton = false;
      } else {
        this.user_bot = true;
        this.disablebutton = true;
      }

      if(!this.disablebutton)
      {
      this.showbutton = false;
      }
  }
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.ref.detach();
    setInterval(() => {
      if (!this.ref['destroyed']) {
        this.ref.detectChanges();
      }
    }, 0);
    if (this.deviceWidth < 768) {
    if (_.isEmpty(this.level1)) {
          this.disablebutton = false;
        } else {
          this.user_bot = true;
          this.disablebutton = true;
        }
    }
    
  }

  getCurrentProvider(event) {
    const provider = this.level1;

    if (_.isEmpty(this.level1)) {
      this.disablebutton = false;
    } else {
      this.user_bot = true;
      this.disablebutton = true;
    }
    this.level1 = provider;

    if (this.deviceWidth < 768) {
      this.commercialService.unSelectService({ currentId: this.data });
      this.user_bot = true;
      this.disablebutton = true;
      this.goNext();
    }
    if (!_.isEmpty(this.level1)) {
      if (_.contains(this.energy_providers_list, this.level1)) {
        this.user_bot = true;
        if (this.deviceWidth < 768) {
          this.user_bot = true;
          this.disablebutton = true;
          this.goNext();
        }else
        {
          if(!this.showbutton)
          {
            this.next();

          }
        }
      } else {
        this.user_bot = true;
       // this.next();

      }
    } else {
      this.user_bot = true;
    }
  }
  onTypeaheadItemSelect(event: TypeaheadMatch): void {
    const selectedValue = event.item; // Access the selected item from the event
    // Handle the selected value as needed

    this.next()
  }
  
  titleCase(str) {
    str = str.toLowerCase().split(' ');
    for (let i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(' ');
  }

  getLevel1(value) {
    this.commercialService.unSelectService({ currentId: this.data });
    this.sub_levels = [];
    this.level2 = undefined;
    this.sub_levels2 = [];
    this.ref.detach();
    if (!this.ref['destroyed']) {
      this.ref.detectChanges();
    }
    this.level1 = value;
    const level1 = _.findWhere(this.businessTypes, { level1: this.level1 });
    this.sub_levels = level1.sub_levels;
    this.disablebutton = true;
  }
  getLevel2(value) {
    this.commercialService.unSelectService({ currentId: this.data });
    this.sub_levels2 = [];
    this.level3 = undefined;
    this.ref.detach();
    if (!this.ref['destroyed']) {
      this.ref.detectChanges();
    }
    this.level2 = value;
    const level2 = _.findWhere(this.sub_levels, { level2: this.level2 });
    this.sub_levels2 = level2.sub_levels;
    this.disablebutton = false;
    if (_.isEmpty(this.sub_levels2)) {
      this.level3 = '';
      this.user_bot = true;
      this.disablebutton = true;
      if (this.deviceWidth < 768) {
        this.time = 1000;
        this.goNext();
      }
    }
  }
  getLevel3(value) {
    this.commercialService.unSelectService({ currentId: this.data });
    this.disablebutton = true;
    this.level3 = value;
    this.user_bot = true;
    if (this.deviceWidth < 768) {
      this.time = 1000;
      this.goNext();
    }
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
        this.showTyping = false;
      }
      this.typingTimer = setTimeout(() => {
        this.showTyping = true;
      }, 250);
      this.timer = setTimeout(() => {
        // // console.log.log(this.time);
        this.showTyping = false;
        this.next();
      }, this.time);
    }
  }

  next() {
    if (
      this.level1 === undefined ||
      this.level1 === '' ||
      this.level1 === null
    ) {
      this.commercialService.unSelectService({ currentId: this.data });
    } else {
      var queryObj = { businesstype: '' };
      queryObj.businesstype = this.level1;
      const body = new HttpParams().append(
        'queryObj',
        JSON.stringify(queryObj)
      );
      this.http
        .post(this.url + '/updateBusinessTypes', body)
        .takeUntil(this.unsubscribe)
        .subscribe((res: any) => {
          console.log('BusinessTypes saved Successfully');
        });

      const Obj = {
        com_question_id: this.data,
        fieldName: 'biz_type',
        fieldValue: this.level1,
      };
      this.commercialService.updateResponses(Obj);
      const loopCountNS = _.findWhere(
        this.commercialService.userResponse.userResponses,
        { com_question_id: '0014' }
      );
      const loopCountSP = _.findWhere(
        this.commercialService.userResponse.userResponses,
        { com_question_id: '0011' }
      );
      if (
        ((!_.isEmpty(loopCountNS) && loopCountNS.fieldValue.length >= 1) ||
          (!_.isEmpty(loopCountSP) && loopCountSP.fieldValue.length >= 1)) &&
        this.deviceWidth > 767
      ) {
        this.commercialService.messageService({
          currentId: '003',
          nextId: '0015',
        });
      } else {
        this.commercialService.messageService({ currentId: this.data });
      }
    }
  }
}
